import React, { useState, useEffect } from "react";
import Select, { ActionMeta, MultiValue } from "react-select";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import index from "@beeldit/core/services";
import { Product } from "../models/Product";
import {t} from "i18next";

interface Option {
  label: string;
  value: number | string;
}

function MultiSelector(props: any) {
  const { id, value, required, disabled, readonly, onChange, maxItems, placeholder } = props;
  const [selectedOptions, setSelectedOptions] = useState<MultiValue<Option>>(
    []
  );
  const [options, setOptions] = useState<Option[]>([]);
  const [elementsData, setElementsData] = useState({ elements: [] });

  const errorHandler = useErrorHandler();

  useEffect(() => {
    index("products")
      .then((response: any) => {
        setElementsData(response.data);
      })
      .catch((error: any) => {
        errorHandler(error, null);
      });
  }, []);

  useEffect(() => {
    const options: any = elementsData.elements.map((product: Product) => {
      return { label: product.name.es, value: product.id };
    });
    setOptions(options);
    const currentSelectedOptions = options.filter((option: any) => {
      if (value && value.includes(option.value)) {
        return true;
      }
    });
    setSelectedOptions(currentSelectedOptions);
  }, [elementsData]);

  const handleOnChange = (
    newValue: MultiValue<Option>,
    actionMeta: ActionMeta<Option>
  ) => {
    if (actionMeta.action === 'clear' || actionMeta.action === 'remove-value' ||
        (actionMeta.action === 'select-option' && (!maxItems || selectedOptions.length < maxItems))) {
      setSelectedOptions(newValue);
      const model = newValue.map((option) => {
        return option.value;
      });
      onChange(model);
    }

  };

  const selectStyles = {
    control: (provided: any) => ({
      ...provided,
      borderColor: "lightgray",
      borderRadius: 0,
    }),
  };

  return (
    <Select
      id={id}
      isMulti
      options={options}
      value={selectedOptions}
      required={required}
      isDisabled={disabled || readonly}
      onChange={handleOnChange}
      styles={selectStyles}
      placeholder={t(placeholder ? placeholder : 'select_products')}

    />
  );
}

function ProductMultiSelector(props: any) {
  const { id, options, value, required, disabled, readonly, onChange } = props;
  return (
    <MultiSelector
      id={id}
      options={options.enumOptions}
      maxItems={options.maxItems}
      placeholder={options.placeholder}
      value={value}
      required={required}
      disabled={disabled}
      readonly={readonly}
      onChange={onChange}
    />
  );
}

export default ProductMultiSelector;
